// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";

import { useMemo } from "@mairistem/tools";

import { ModuleService } from "../services";

import { DataProvider } from "../../libs/components/DataProvider";

export const ModuleDataProvider = (props) => {
	const { children, domain } = props;

	const [modules, loading, fetching] =
		ModuleService.queryModulesByDomain(domain);

	return useMemo(
		() => (
			<DataProvider data={modules} loading={loading} fetching={fetching}>
				{children}
			</DataProvider>
		),
		[children, loading, fetching, modules],
	);
};
